import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_PHYSICIANS_REQUEST, fetchPhysiciansSuccess, fetchPhysiciansFailure,
  CREATE_PHYSICIAN_REQUEST, createPhysicianSuccess, createPhysicianFailure,
  UPDATE_PHYSICIAN_REQUEST, updatePhysicianSuccess, updatePhysicianFailure,
  DELETE_PHYSICIAN_REQUEST, deletePhysicianSuccess, deletePhysicianFailure
} from '../actions/physicianActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

function* fetchPhysicians(action) {
  try {
    const token = getAuthToken();
    const { projectId, page = 1, limit = 1, search = '', group = '' } = action.payload || {};
    
    console.log("Fetching phy with payload: ", action.payload);

    const response = yield call(
      axios.get,
      `${getBaseUrl()}/${projectId}/physician`, // Updated endpoint
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Expecting `data` and `meta` in the response
    yield put(fetchPhysiciansSuccess(response.data));
  } catch (error) {
    console.error("Error fetching Physician: ", error);
    yield put(fetchPhysiciansFailure(error.response?.data?.message || error.message));
  }
}


function* createPhysician(action) {
    try {
      const response = yield call(axios.post, `${API_BASE_URL}/${action.payload.projectId}/physician`, action.payload.data, {
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });
      yield put(createPhysicianSuccess(response.data));
    } catch (error) {
      yield put(createPhysicianFailure(error.message));
    }
  }

function* updatePhysician(action) {
  try {
    const { id, data,projectId } = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/physician/${id}`, data, {
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });
    yield put(updatePhysicianSuccess(response.data));
  } catch (error) {
    yield put(updatePhysicianFailure(error.message));
  }
}

function* deletePhysician(action) {
  try {
    const { id, projectId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/${projectId}/physician/${id}`, {
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });
    yield put(deletePhysicianSuccess(id));
  } catch (error) {
    yield put(deletePhysicianFailure(error.message));
  }
}

export default function* physicianSaga() {
  yield takeLatest(FETCH_PHYSICIANS_REQUEST, fetchPhysicians);
  yield takeLatest(CREATE_PHYSICIAN_REQUEST, createPhysician);
  yield takeLatest(UPDATE_PHYSICIAN_REQUEST, updatePhysician);
  yield takeLatest(DELETE_PHYSICIAN_REQUEST, deletePhysician);
}
